import styled from "styled-components"
import { theme } from "Theme"

const Wrapper = styled.section`
  justify-content: space-between;
  align-items: center;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    align-items: center;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 0;
`

export default Wrapper
